export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto rounded-2xl border border-background-200/60 bg-background-100/50 p-8 md:p-10">
          <div className="flex flex-col md:flex-row items-center gap-6 md:gap-10">
            <div className="flex-1 text-center md:text-left">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
                移动端吃瓜入口
              </h2>
              <p className="mt-3 text-sm text-foreground-500 leading-relaxed">
                随时随地掌握51吃瓜旗下台北娜娜、莫里秀、玩偶姐姐等热门人物的最新动态。暗网吃瓜移动端专为吃瓜爱好者打造，支持实时推送、离线阅读，让你不错过任何一条独家爆料。每日更新同步，打开即看。
              </p>
              <div className="mt-5 flex flex-col sm:flex-row items-center gap-3 justify-center md:justify-start">
                <a
                  href="#"
                  onClick={(e) => e.preventDefault()}
                  className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold text-sm rounded-lg transition-all duration-200 whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-smartphone-line"></i>
                  移动端访问入口
                </a>
                <a
                  href="#"
                  onClick={(e) => e.preventDefault()}
                  className="inline-flex items-center gap-2 px-6 py-3 border border-background-300 hover:border-primary-400 text-foreground-600 hover:text-primary-400 font-medium text-sm rounded-lg transition-all duration-200 whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-qr-code-line"></i>
                  扫码直达
                </a>
              </div>
            </div>
            <div className="flex-shrink-0">
              <div className="w-40 h-40 md:w-48 md:h-48 rounded-2xl bg-background-200 flex items-center justify-center">
                <i className="ri-smartphone-line text-6xl text-foreground-400"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}